export default {

    'SUPER' : 1,
    'COURSE_VOD' : 2,
    'DATUM' : 3

};



/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/data/vipTypeEnum.js
 **/